import { selectCognitoUserObject } from 'utils/cognito.util';
import { isEnvCy } from 'utils/env/determine.util';
import logger from 'utils/logger.util';
import isFn from 'utils/predicates/function/isFn.util';

import AT from './resendConfirmationCode.type';

const L = logger('resendConfirmationCode');

// noinspection DuplicatedCode
const mockResendConfirmationCode = () => (dispatch) => {
  const data = '';

  dispatch(L.debug('mockResendConfirmationCode()', 'init:', { type: AT.init }));
  dispatch(L.debug('mockResendConfirmationCode()', 'pass:', { type: AT.pass, data }));
  dispatch(L.debug('mockResendConfirmationCode()', 'done:', { type: AT.done }));

  return Promise.resolve(data);
};

// FIXME: mocking should be part of the Cypress tests not the regular code
const resendConfirmationCode = isEnvCy()
  ? mockResendConfirmationCode
  : () => (dispatch, getState) => {
      // SEE: https://www.npmjs.com/package/amazon-cognito-identity-js
      // SEE: https://github.com/aws-amplify/amplify-js

      const user = selectCognitoUserObject(getState());
      dispatch({ type: AT.init });

      const promise = new Promise((resolve, reject) => {
        try {
          if (isFn(user && user.resendConfirmationCode)) {
            // SEE: node_modules/amazon-cognito-identity-js/index.d.ts
            user.resendConfirmationCode((error, result) => (error ? reject(error) : resolve(result)));
          } else {
            reject(new Error("Can't request verification code, maybe not logged in or invalid user:", user));
          }
        } catch (e) {
          reject(e);
        }
      });

      promise
        .then((m) => dispatch({ type: AT.pass, data: L.debug('()', 'then()', m) }))
        .catch((e) => dispatch({ type: AT.fail, data: L.warn('()', 'catch()', { user }, e) }))
        .finally(() => dispatch({ type: AT.done }));

      return promise;
    };

// noinspection JSUnusedGlobalSymbols
export default resendConfirmationCode;
